export default __webpack_public_path__ + "static/media/welcome.6b0fb518.webp";